import { css, fillOutlined, circle } from './draw-utils';
import type { ProceduralDef } from '../types';

const CARAPACE = 0x4a2d5a; // dark spider purple
const LEG = 0x8a5cd0;

/**
 * Webspinner — a spider that strings laser threads across the
 * arena. Frame 0 idle / 1 spinning (legs flare). docs/02 boss pool.
 */
export const bossWebspinnerBody: ProceduralDef = {
  key: 'boss/webspinner/body',
  width: 160,
  height: 160,
  anchorX: 0.5,
  anchorY: 0.5,
  frames: 2,
  draw(ctx, w, h, frame) {
    const c = w / 2;
    const spinning = frame === 1;

    if (spinning) {
      const halo = ctx.createRadialGradient(c, c, 16, c, c, c);
      halo.addColorStop(0, 'rgba(138,92,208,0.4)');
      halo.addColorStop(1, 'rgba(138,92,208,0)');
      circle(ctx, c, c, c);
      ctx.fillStyle = halo;
      ctx.fill();
    }

    // Eight legs
    ctx.strokeStyle = css(LEG);
    ctx.lineWidth = 5;
    ctx.lineCap = 'round';
    ctx.lineJoin = 'round';
    for (let i = 0; i < 8; i++) {
      const a = (Math.PI * 2 * i) / 8 + Math.PI / 8;
      const knee = spinning ? 0.5 : 0.3;
      const k1x = c + Math.cos(a) * 34;
      const k1y = c + Math.sin(a) * 34;
      const k2x = c + Math.cos(a + knee) * 58;
      const k2y = c + Math.sin(a + knee) * 58;
      const tx = c + Math.cos(a) * 72;
      const ty = c + Math.sin(a) * 72;
      ctx.beginPath();
      ctx.moveTo(k1x, k1y);
      ctx.lineTo(k2x, k2y);
      ctx.lineTo(tx, ty);
      ctx.stroke();
    }

    // Abdomen + head
    circle(ctx, c, c + 8, 30);
    fillOutlined(ctx, CARAPACE, 5);
    circle(ctx, c, c - 22, 18);
    fillOutlined(ctx, CARAPACE, 4);

    // Cluster eyes
    ctx.fillStyle = css(spinning ? 0xff6b6b : 0xc77dff);
    for (const [ox, oy] of [[-7, -26], [7, -26], [-4, -18], [4, -18]] as const) {
      circle(ctx, c + ox, c + oy, 3.2);
      ctx.fill();
    }
    void h;
  },
};
